import moment from "moment-jalaali";

export function getCurrencyFormat(value) {
    return `${value}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function convertAndRoundUp(str) {
    const num = parseFloat(str);
    return Math.ceil(num);
}
export function convertAndRound(str) {
    const numerator = str.split('.')[0];
    const denominator = str.split('.')[1];
    const decimalDigits = String(denominator).slice(0, 2);
    let den;
    if (decimalDigits.length === 2) {
        den = Number(decimalDigits) >= 50 ? 1 : 0;
    } else {
        const firstDigit = Number(decimalDigits[0]);
        den = firstDigit >= 5 ? 1 : 0;
    }
    return parseInt(numerator) + den;
}


export const roundNumber = (val) => {
    if (val)
        return Math.round(val)
    else
        return 0
}

export const convertToEnglishNumbers = (value) => {
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

    let convertedValue = value;

    persianNumbers.forEach((num, index) => {
        console.log("val", convertedValue)
        convertedValue = convertedValue.replace(num, index);
    });

    arabicNumbers.forEach((num, index) => {
        convertedValue = convertedValue.replace(num, index);
    });

    return convertedValue.replace(/[^0-9]/g, '');
};

export const pharmacyMedOrderStatus = (code) => {
    let result = "";
    switch (code) {
        case 1:
            result = "نسخه جدید";
            break;
        case 2:
            result = "تایید شده توسط داروخانه";
            break;
        case 3:
            result = "در انتظار پرداخت مشتری";
            break;
        case 4:
            result = "پرداخت شده توسط مشتری";
            break;
        case 5:
            result = "توسط داروخانه رد شده";
            break;
        case 6:
            result = "توسط مشتری لغو شد";
            break;
        case 8:
            result = "در انتظار نسخه پیچی";
            break;
        case 9:
            result = "در انتظار ثبت صندوق";
            break;
        case 10:
            result = "در انتظار تحویل";
            break;
        case 11:
            result = "تحویل شده";
            break;
        default:
            result = "";
    }

    return result;
};


export const medOrderStatusColor = (code) => {
    let result = "";
    switch (code) {
        case 1:
            result = "#78B563";
            break;
        case 2:
            result = "#B0F1FF";
            break;
        case 3:
            result = "#7EE8FF";
            break;
        case 4:
            result = "#8FADFA";
            break;
        case 5:
            result = "#DE001B";
            break;
        case 6:
            result = "#FF9254";
            break;
        case 8:
            result = "#8FADFA";
            break;
        case 9:
            result = "#4C79ED";
            break;
        case 10:
            result = "#0041E9";
            break;
        case 11:
            result = "#002FA7";
            break;
        default:
            result = "";
    }

    return result;
};

export const checkFileSize = (size,limit)=>{
    let fileSize = Math.floor(size/1000000)
    return fileSize<=limit
}

export const sleep = (time)=>{
    setTimeout(()=>{
        console.log("wakeup")
    },time)
}

export const delay = (seconds) => {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
};


export const removeSecond = (time)=>{
    if(!time)
        return ""

    let arr = time.split(":")
    return arr[0]+":"+arr[1]
}

export function isNumeric(num){
    return !isNaN(num)
}

// function isNumeric(str) {
//     if (typeof str != "string") return false // we only process strings!
//     return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
//         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
// }


export function getCampaignCardStatus(isActive,status){

    if(status==="finished")
        return "منقضی شده"

    if(isActive){
        if(status==="created" || status==="started")
            return "فعال"
    }

    if(!isActive){
        if(status==="created" || status==="started")
            return "غیر فعال"
    }

}

export function getCampaignCardStatusColor(isActive,status){

    if(status==="finished")
        return "#e5be48"

    if(isActive){
        if(status==="created" || status==="started")
            return "#68B66B"
    }

    if(!isActive){
        if(status==="created" || status==="started")
            return "#f86262"
    }

}

export function getCampaignCardLifeStatus(isActive,status){

    if(status==="finished")
        return "منقضی شده"

    if(isActive){
        if(status==="not_started" || status==="in_progress")
            return "فعال"
    }

    if(!isActive){
        if(status==="not_started" || status==="in_progress")
            return "غیر فعال"
    }

}

export function getCampaignCardLifeStatusColor(isActive,status){

    if(status==="finished")
        return "#e5be48"

    if(isActive){
        if(status==="not_started" || status==="in_progress")
            return "#68B66B"
    }

    if(!isActive){
        if(status==="not_started" || status==="in_progress")
            return "#f86262"
    }

}

export const sleepy = (seconds) => {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
};

export function numberWithCommasHelper(x) {
    if (x) {
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    } else {
        return " - "
    }
}

export const formatGregorianToJalaliMonthLabel = (gregorianDateString) => {
    try {
        // پارس کردن تاریخ میلادی
        const date = moment(gregorianDateString);

        // تبدیل به تاریخ شمسی
        const jalaliDate = date.clone();

        // گرفتن سال و ماه شمسی
        const year = jalaliDate.jYear();
        const monthName = jalaliDate.format('jMMMM'); // نام ماه به فارسی

        return `${monthName} ${year}`;
    } catch (error) {
        console.error('Error converting date:', error, gregorianDateString);
        return 'تاریخ نامعتبر';
    }
};

export const isValidURL = (str) => {
    const pattern = /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/\S*)?$/;
    return pattern.test(str);
};


export const RewardConvertToJalali = (date) => {
    return moment.utc(date.split("+")[0]).format(" HH:mm - jYYYY/jMM/jDD");
};


export const convertInvoiceState = (state) => {
    let result = "";
    switch (state) {
        case "success_to_pay":
            result = "پرداخت شده";
            break;
        case "invalidated":
            result = "منقضی شده";
            break;
        case "waiting_to_pay":
            result = "منتظر پرداخت";
            break;
        case "failed_to_pay":
            result = "پرداخت ناموفق";
            break;

    }
    return result;
};

export function persianNumber(string) {
    return string.split('0').join('۰')
        .split('1').join('۱')
        .split('2').join('۲')
        .split('3').join('۳')
        .split('4').join('۴')
        .split('5').join('۵')
        .split('6').join('۶')
        .split('7').join('۷')
        .split('8').join('۸')
        .split('9').join('۹')
}

export function englishNumber(string) {
    return string.split('۰').join('0')
        .split('۱').join('1')
        .split('۲').join('2')
        .split('۳').join('3')
        .split('۴').join('4')
        .split('۵').join('5')
        .split('۶').join('6')
        .split('۷').join('7')
        .split('۸').join('8')
        .split('۹').join('9')
}

export function removeDecimal(str) {
    return str.split('.')[0];
}

export function convertRialToTomanFloor(x) {
    if (x) {
        return Math.floor(x / 10);
    } else {
        return "0";
    }
}


export function decodeContentDisposition(contentDisposition) {
    if (!contentDisposition) return 'download.xlsx';

    // بررسی حالت URL-encoded
    const urlEncodedMatch = contentDisposition.match(/filename\*?=['"]?utf-8''([^;]*)/i);
    if (urlEncodedMatch) {
        return decodeURIComponent(urlEncodedMatch[1]);
    }

    // بررسی حالت Base64
    const base64Match = contentDisposition.match(/\?b\?(.+?)\?=/);
    if (base64Match) {
        return Buffer.from(base64Match[1], 'base64').toString('utf-8');
    }

    return 'download.xlsx';
}

export const convertTransactionName = (n) => {
    switch (n) {
        case 'services_message':
            return "پیام‌های خدماتی"
            break;
        case 'campaign_message':
            return "پیام‌های کمپین"
            break;
        case 'bulk_message':
            return "پیام‌های انبوه"
            break;
        case 'subscription':
            return "آبونمان"
            break;
        default:
            return n
    }
}

export function numberToPersianWords(num, unit = "ریال") {

    if (typeof num !== "number") {
        return " "
        // throw new Error("عدد ورودی معتبر نیست");
    }

    const yekan = [
        "",
        "یک",
        "دو",
        "سه",
        "چهار",
        "پنج",
        "شش",
        "هفت",
        "هشت",
        "نه",
        "ده",
        "یازده",
        "دوازده",
        "سیزده",
        "چهارده",
        "پانزده",
        "شانزده",
        "هفده",
        "هجده",
        "نوزده",
    ];
    const dahgan = [
        "",
        "",
        "بیست",
        "سی",
        "چهل",
        "پنجاه",
        "شصت",
        "هفتاد",
        "هشتاد",
        "نود",
    ];
    const sadgan = [
        "",
        "یکصد",
        "دویست",
        "سیصد",
        "چهارصد",
        "پانصد",
        "ششصد",
        "هفتصد",
        "هشتصد",
        "نهصد",
    ];
    const bigScales = [
        "",
        "هزار",
        "میلیون",
        "میلیارد",
        "تریلیون",
        "کادریلیون",
    ];

    if (num === 0) return "صفر " + unit;

    function threeDigitsToWord(n) {
        let res = [];
        let s = Math.floor(n / 100);
        let d = n % 100;

        if (s > 0) res.push(sadgan[s]);

        if (d > 0) {
            if (d < 20) {
                res.push(yekan[d]);
            } else {
                let da = Math.floor(d / 10);
                let y = d % 10;
                res.push(dahgan[da]);
                if (y > 0) res.push(yekan[y]);
            }
        }

        return res.join(" و ");
    }

    let parts = [];
    let scaleIndex = 0;

    while (num > 0) {
        let chunk = num % 1000;
        if (chunk > 0) {
            let chunkWords = threeDigitsToWord(chunk);
            if (bigScales[scaleIndex]) {
                chunkWords += " " + bigScales[scaleIndex];
            }
            parts.unshift(chunkWords);
        }
        num = Math.floor(num / 1000);
        scaleIndex++;
    }

    return parts.join(" و ") + " " + unit;
}

export function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export const ISMonetarySmartGoal = (type)=>{
    switch (type) {
        case "invoice_item_quantity_average":
            return "quantity";
            break;
        case "invoice_amount_sum":
            return "monetary";
            break;
        case "invoice_amount_average":
            return "monetary";
            break;
        case "high_amount_invoice_count":
            return "quantity";
            break;
        default :
            return true

    }
}
